// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3Cfcf","label":"styles_label__o7sSC","icon":"styles_icon__Dx__R"};